
<div class="inner-adjust">
  <div class="pt-3 pb-2 mb-3 border-bottom">
    <h1>Profil utilisateur</h1>
  </div>
  <!-- Show user data when logged in -->
  <div class="row" *ngIf="authService.userData as user">
    <div class="col-md-12">
      <div class="media">
        <div class="media-body" *ngIf="joueur != null">
          Bonjour {{(user.displayName) ? user.displayName : 'User'}}!
          <br />
          <br />
          <p><span class="label">Nom: </span>{{joueur.nomComplet}}</p>
          <p><span class="label">Courriel: </span>{{user.email}}</p>
          <p><span class="label">Adresse: </span>{{joueur.adresse}}</p>
          <p><span class="label">Téléphone: </span>{{joueur.telephone}}</p>
          <p><span class="label">Date de naissance: </span>{{joueur.dateDeNaissance | date:'yyyy-MM-dd'}}</p>
          <p><span class="label">Contact d'urgence: </span>{{joueur.contactUrgence.nomComplet}} - {{joueur.contactUrgence.relation}} ({{joueur.contactUrgence.numero}})</p>
          <p><span class="label">Autres informations: </span>{{joueur.autreInformation}}</p>

          <button type="button" routerLink="/dashboard/update" class="btn mt-3">
            Modifier
          </button>
        </div>
      </div>
    </div>
  </div>
</div>